// =============================================================================
// forecastMenu.js — WHICH ROLLS the forecast is split across. Lane BQ, PR 2 of 2, 13 Sep 2026.
// PURE, network-free.
//
// WHAT THE LIVE ENGINE DOES (ManchesterForecastEngine.js getSkuSplit, read 13 Sep 2026):
//   1. currentNames = the names in its warm Square-catalog cache (roll_name_map: every
//      item in the Rolls category), de-duplicated by exact name, excluded items dropped;
//   2. if that list is EMPTY (cold cache) → the names that actually traded in the window;
//   3. then ALWAYS_RETAIN is appended (case-insensitive check) — done for us by
//      forecast.js skuSplit (cfg.alwaysRetain), which also re-applies isExcludedItem.
// A roll on the list with no history is "new" and gets newSkuMinimum (10 TC / 8 Arndale),
// which is why a freshly-launched roll must be ON the list to be made at all (blocker B5).
//
// Here the list is migration 1322's `menu` key on the 1120 bundle — the site's active
// forecast_menu_items names. Empty/absent → today's traded-names path, byte-identical.
// =============================================================================

// The bundle's menu as a clean, de-duplicated list of names — or null when there is no
// usable list (absent, not an array, or empty), which is the engine's "cold cache".
export function menuNamesFromBundle(bundle) {
  const m = bundle && bundle.menu;
  if (!Array.isArray(m)) return null;
  const out = [];
  const seen = new Set();
  for (const n of m) {
    if (typeof n !== "string") continue;
    const t = n.trim();
    if (!t || seen.has(t)) continue;   // exact-name de-dupe, as the engine's `seen[n]`
    seen.add(t);
    out.push(t);
  }
  return out.length ? out : null;
}

// The engine's precedence: the menu when it has names, else what traded.
export function currentNamesFor(bundle, tradedNames) {
  return menuNamesFromBundle(bundle) || (tradedNames || []);
}
